import { ExecutionResults, Implementation } from "./types"; // Added Implementation import

// Adjust this base URL if your API is hosted elsewhere or configured differently
// const API_BASE_URL = process.env.GATSBY_API_URL || "http://127.0.0.1:8000";

export const fetchExecutionResults = async (
  baseUrl: string,
  // framework: string, // No longer needed directly in the fetch logic
  // usecaseId: string, // No longer needed directly in the fetch logic
  implementation: Implementation // Pass the whole implementation object
): Promise<ExecutionResults | null> => {
  // Check if results path exists
  if (!implementation.results?.path) {
    console.warn(
      `No results path defined for framework: ${implementation.framework}`
    );
    return null;
  }

  // Construct the URL to the static results.json file
  const url = `${baseUrl}${implementation.results.path}`;

  try {
    const response = await fetch(url, {
      method: "GET", // Use GET to fetch the static file
      // headers: { // Headers likely not needed for static file fetch
      //   "Content-Type": "application/json",
      // },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error(
        `API Error (${response.status}) fetching results file ${url}: ${errorText}`
      );
      throw new Error(
        `Failed to fetch execution results from ${url}. Status: ${response.status}`
      );
    }

    const data: ExecutionResults = await response.json();
    return data;
  } catch (error) {
    console.error(
      `Network or fetch error fetching results file ${url}:`,
      error
    );
    throw error; // Re-throw to be caught by Promise.all
  }
};
